import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Axios from 'axios';

const Register = () => {
   const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [name, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

 const handleRegister = async (event) => {
  event.preventDefault();

  if (!username || !name || !email || !password) {
    setError('Please fill all the required fields.');
    return;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    setError('Please enter a valid email address.');
    return;
  }

  const termsCheckbox = document.getElementById('terms');
  if (!termsCheckbox.checked) {
    setError('Please accept the terms and conditions.');
    return;
  }

    try {
      const response = await Axios.post('https://dayoffice24.it/api/register', {
        name: name,
        email: email,
        password: password,
        assign_role: 'visitor',
        username: username,
      });

      if (response.data.success) {
        setError('');
        setSuccessMessage('Registration successful. You can now login with your credentials.');
        // Clear form fields after successful registration
        setUsername('');
        setFullName('');
        setEmail('');
        setPassword('');

        // Use setTimeout to add a 0.5-second delay before redirecting
        setTimeout(() => {
          navigate('/Login'); // Redirect to the Login page
        }, 500);
      } else {
        setError(response.data.message); // Set the error message from the API response
        setSuccessMessage('');
      }
    } catch (error) {
      setError('An error occurred. Please try again later.');
      setSuccessMessage('');
    }
  };


  return (
    <div className="main_wrap">
      <Header />
      <div className="content-wrapper">
        <section className="property-details-wrap pt-75 pb-75">
          <div className="container">
            <div className="row align-items-center login_bg gx-5">
              <div className="col-md-6">
                <div className="login-bg bg-f"></div>
              </div>
              <div className="col-md-6">
                <div className="login-content">
                  <h2>Sign Up</h2>
                  <p>Please fill the form to create an account</p>
                  <form className="user-form" onSubmit={handleRegister} action="#">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            id="username"
                            name="username"
                            type="text"
                            placeholder="Username"
                            required=""
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            id="fname"
                            name="name"
                            type="text"
                            placeholder="Full Name"
                            required=""
                            value={name}
                            onChange={(e) => setFullName(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            id="email"
                            name="email"
                            type="email"
                            placeholder="Email"
                            required=""
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            id="pwd_2"
                            name="pwd_2"
                            type="password"
                            placeholder="Password"
                            required=""
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input type="hidden" name="assign_role" value="visitor" />
                        </div>
                      </div>
                      <div className="col-sm-12 col-12">
                       <div className="checkbox style3">
                         <input type="checkbox" id="terms" />
                         <label htmlFor="terms">
                           I Agree with the{' '}
                           <a className="link style1" href="#">
                             Terms &amp; conditions
                           </a>{' '}
                           &amp;{' '}
                           <a className="link style1" href="#">
                             privacy policy
                           </a>
                         </label>
                       </div>
                     </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <button className="btn style1">Register Now</button>
                        </div>
                      </div>
                      {error && (
                        <div className="col-lg-12">
                          <p className="text-danger">{error}</p>
                        </div>
                      )}
                      {successMessage && (
                        <div className="col-lg-12">
                          <p className="text-success">{successMessage}</p>
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Register;
